import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { useRouter } from 'vue-router';


export default /*@__PURE__*/_defineComponent({
  __name: 'HomeView',
  setup(__props) {

const router = useRouter();

const navigate = (path: string) => {
  router.push(path);
};

return (_ctx: any,_cache: any) => {
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, { class: "pt-16 card-list" }, {
    default: _withCtx(() => [
      _createVNode(_component_v_card, {
        class: "mb-8 bg-primary card",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (navigate('/stories')))
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_card_text, null, {
            default: _withCtx(() => _cache[12] || (_cache[12] = [
              _createElementVNode("h2", null, "Stories", -1),
              _createElementVNode("p", null, "Manage content stories which lead to actions", -1)
            ])),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_v_card, {
        class: "mb-8 bg-primary card",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (navigate('/quiz-of-the-day')))
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_card_text, null, {
            default: _withCtx(() => _cache[13] || (_cache[13] = [
              _createElementVNode("h2", null, "Quiz of the day", -1),
              _createElementVNode("p", null, "Manage how stories show up in the quiz of the day", -1)
            ])),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_v_card, {
        class: "mb-8 bg-primary card",
        onClick: _cache[2] || (_cache[2] = ($event: any) => (navigate('/categories')))
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_card_text, null, {
            default: _withCtx(() => _cache[14] || (_cache[14] = [
              _createElementVNode("h2", null, "Categories", -1),
              _createElementVNode("p", null, "Manage the categories", -1)
            ])),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_v_card, {
        class: "mb-8 bg-primary card",
        onClick: _cache[3] || (_cache[3] = ($event: any) => (navigate('/users')))
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_card_text, null, {
            default: _withCtx(() => _cache[15] || (_cache[15] = [
              _createElementVNode("h2", null, "Users", -1),
              _createElementVNode("p", null, "Manage users", -1)
            ])),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_v_card, {
        class: "mb-8 bg-primary card",
        onClick: _cache[4] || (_cache[4] = ($event: any) => (navigate('/co2quiz')))
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_card_text, null, {
            default: _withCtx(() => _cache[16] || (_cache[16] = [
              _createElementVNode("h2", null, "CO2 Quiz", -1),
              _createElementVNode("p", null, "Manage the questions for the CO2 quiz", -1)
            ])),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_v_card, {
        class: "mb-8 bg-primary card",
        onClick: _cache[5] || (_cache[5] = ($event: any) => (navigate('/bpt')))
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_card_text, null, {
            default: _withCtx(() => _cache[17] || (_cache[17] = [
              _createElementVNode("h2", null, "BPT Questions", -1),
              _createElementVNode("p", null, "Manage the questions for the BPT scan", -1)
            ])),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_v_card, {
        class: "mb-8 bg-primary card",
        onClick: _cache[6] || (_cache[6] = ($event: any) => (navigate('/content')))
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_card_text, null, {
            default: _withCtx(() => _cache[18] || (_cache[18] = [
              _createElementVNode("h2", null, "Content", -1),
              _createElementVNode("p", null, " Manage the content of the stories, questions, actions, info and hero pages ", -1)
            ])),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_v_card, {
        class: "mb-8 bg-primary card",
        onClick: _cache[7] || (_cache[7] = ($event: any) => (navigate('/learning')))
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_card_text, null, {
            default: _withCtx(() => _cache[19] || (_cache[19] = [
              _createElementVNode("h2", null, "Learning", -1),
              _createElementVNode("p", null, "Manage the learning items", -1)
            ])),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_v_card, {
        class: "mb-8 bg-primary card",
        onClick: _cache[8] || (_cache[8] = ($event: any) => (navigate('/labels')))
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_card_text, null, {
            default: _withCtx(() => _cache[20] || (_cache[20] = [
              _createElementVNode("h2", null, "Labels", -1),
              _createElementVNode("p", null, " Manage the labels that can be assigned to users which are used to personalize their experience ", -1)
            ])),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_v_card, {
        class: "mb-8 bg-primary card",
        onClick: _cache[9] || (_cache[9] = ($event: any) => (navigate('/data-tables')))
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_card_text, null, {
            default: _withCtx(() => _cache[21] || (_cache[21] = [
              _createElementVNode("h2", null, "Data tables", -1),
              _createElementVNode("p", null, "Manage data used for co2 calculations.", -1)
            ])),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_v_card, {
        class: "mb-8 bg-primary card",
        onClick: _cache[10] || (_cache[10] = ($event: any) => (navigate('/feedback')))
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_card_text, null, {
            default: _withCtx(() => _cache[22] || (_cache[22] = [
              _createElementVNode("h2", null, "Feedback", -1),
              _createElementVNode("p", null, "See feedback from users from the app", -1)
            ])),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_v_card, {
        class: "mb-8 bg-primary card",
        onClick: _cache[11] || (_cache[11] = ($event: any) => (navigate('/statistics')))
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_card_text, null, {
            default: _withCtx(() => _cache[23] || (_cache[23] = [
              _createElementVNode("h2", null, "Statistics", -1),
              _createElementVNode("p", null, "See some statistics based on the data in the CMS.", -1)
            ])),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})